import React, { useState, useEffect } from 'react';

import { trackPromise } from 'react-promise-tracker';

import {
    listarCategorias,
    listarCategoriaProdutoBuyer,
    cadastrarCategoriaProdutoBuyer,
    removerCategoriaProdutoBBuyer
} from '../../../../services/http/buyerService';

import services from '../../../../services';

import { useSnackBar } from '../../../../hooks/snackBar';

import TableHeader from '../../../../components/Table/TableHeader';
import TablePagination from '../../../../components/Table/TablePagination';
import Modal from '../../../../components/Modal';

import { 
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from '@material-ui/core';

import './styles.scss';

const tabelaColunas = ['Categoria', ''];

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const CategoriaProdutoBuyer = ({
    idEmpresa,
    cancelar
}) => {
    const { addSnackBar } = useSnackBar();
    const [showModal, setShowModal] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [envioNovasCategorias, setEnvioNovasCategorias] = useState([]);
    const [adicionarCategoria, setAdicionarCategoria] = useState({
        descricao: ""
    })
    const [listaCategoriasProduto, setlistaCategoriasProduto] = useState({
        numeroPagina: 0,
        totalPaginas: 0,
        lista: [],
        tamanhoPagina: 0,
        hasPreviousPage: false,
        hasNextPage: false
    })

    const handleShowModal = () => {
        handlelistarCategorias();
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }

    useEffect(() => {
        carregarListarCategoriasBuyer(1);
    }, [])

    const carregarListarCategoriasBuyer = (pagina) => {
        trackPromise(
            listarCategoriaProdutoBuyer(idEmpresa, pagina)
                .then(res => {
                    setlistaCategoriasProduto(res.data);
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const adicionarNovaCategoria = () => {

        let existeCategoria = listaCategoriasProduto.lista?.find(item => item.descricao == adicionarCategoria.descricao);

        if (existeCategoria) {
            addSnackBar({
                message: 'Categoria já inserida',
                info: 'warning',
                open: true
            })
            return;
        }

        setEnvioNovasCategorias(prevent => [...prevent, adicionarCategoria.descricao]);

        setlistaCategoriasProduto((prevent) => ({
            ...prevent,
            lista:[
                ...prevent.lista,
                {
                    descricao: adicionarCategoria.descricao
                }
            ]
        }))

        handleCloseModal();
    }

    const handlelistarCategorias = () => {
        trackPromise(
            listarCategorias()
                .then(res => {

                    if (res.data.length > 0) {
                        setCategorias(res.data);
                        setShowModal(true)
                    } else {
                        addSnackBar({
                            message: 'Não existem categorias cadastradas',
                            info: 'warning', 
                            open: true
                        })
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const mudarPagina = (pagina) => {
        carregarListarCategoriasBuyer(pagina);
    }

    const changesDadosCategoriaProduto = (value, propertie) => {
        setAdicionarCategoria((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const handleCadastrarCategorias = () => {
        if (envioNovasCategorias.length <= 0) {
            return;
        }

        trackPromise(
            cadastrarCategoriaProdutoBuyer(idEmpresa, { descricao: envioNovasCategorias.join(';') })
                .then(res => {
                    if (!res.fail) {
                        addSnackBar({
                            message: 'Categorias cadastradas com sucesso',
                            info: 'success',
                            open: true
                        })
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const removerCategoria = (idCategoriaProdutoBuyer) => {
        trackPromise(
            removerCategoriaProdutoBBuyer(idCategoriaProdutoBuyer)
                .then(res => {
                    console.log(res);
                    carregarListarCategoriasBuyer(1);
                })
        ).catch(error => {  
            console.log(error);
        })
    }

    return (
        <div className='ml-1 mt20'>
            <div className='row'>
                <div className='col-sm-12 col-md-12 col-lg-12 descricao'>
                    <h1 className='label-second'>Categorias Cadastradas</h1>
                </div>
            </div>
            <div className='row mt20'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button 
                        onClick={handleShowModal} className="buton-green btn-adicionar-categoria btn btn-block btn-lg mt20"
                    >
                        ADICIONAR CATEGORIA
                    </button>
                </div>
            </div>
            <div className="row mt20">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />
                            <tbody>
                                {
                                    (!listaCategoriasProduto || !listaCategoriasProduto?.lista || listaCategoriasProduto?.lista.length === 0) &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }
                                {
                                    listaCategoriasProduto.lista  && listaCategoriasProduto.lista.map((item) => (
                                        <tr key={item.id}>
                                            <td> { item.descricao } </td>
                                            <td className="text-right">
                                                <i className="btn-remove-icon btn btn-icon fa fa-times" onClick={() => removerCategoria(item.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={listaCategoriasProduto} changePage={mudarPagina} />
                    </div>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button 
                    className="col-sm-5 col-md-5 col-lg-5 buton-white-black-border" 
                    onClick={() => cancelar(1)}
                >
                        CANCELAR
                </button>
                <button 
                    className="col-sm-5 col-md-5 col-lg-5 buton-green" 
                    onClick={handleCadastrarCategorias}
                >
                        SALVAR
                </button>
            </div>

            <Modal
                open={showModal} close={handleCloseModal} 
                type="modal-recuperar-senha" 
                size="lg"
                className="row"
                classTop="modal-title">
                <div className="modal-content col-sm-12 col-md-12 col-lg-12">
                  <p className='col-sm-12 col-md-12 col-lg-12'>Adicionar Categoria</p>
                  <div className='col-sm-12 col-md-12 col-lg-12'>
                  <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Informe a categoria</InputLabel>
                    <Select
                        required
                        className="select"
                        variant="outlined"
                        value={adicionarCategoria.descricao || 'selecione'}
                        label="Informe a categoria"
                        onChange={event => changesDadosCategoriaProduto(event.target.value, 'descricao')}
                        MenuProps={MenuProps}
                    >
                        <MenuItem disabled={true} value={"selecione"}>
                            <em>Selecione a categoria</em>
                        </MenuItem>

                        {categorias.map(item =>
                            <MenuItem key={item.id} value={item.descricao}>{item.descricao}</MenuItem>
                        )}
                    </Select>
                  </FormControl>
                  </div>
                  <div className='col-sm-12 col-md-12 col-lg-12'>
                    <button
                      className="col-sm-12 col-md-12 col-lg-12 mt20 buton-green"
                      onClick={adicionarNovaCategoria}
                    >
                      SALVAR
                    </button>
                  </div>
                </div>
            </Modal>
        </div>
    )
}

export default CategoriaProdutoBuyer;